import { getters } from '/@/modules/core/app/helpers/store';
import { RouteConfig } from '/@/modules/core/app/helpers/RouteConfig';

export class ManageEstateRouteConfig extends RouteConfig {
  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    return getters.auth.getUser().isManagingEstates;
  }
}
